import StoreCatalog from '../../../components/StoreCatalog'
export default function DefaultTemplate(props) { return <StoreCatalog {...props} restaurant /> }
